__turbopack_context__.v({
  "desktopActions": "Header-module__hBw1pG__desktopActions",
  "desktopNav": "Header-module__hBw1pG__desktopNav",
  "header": "Header-module__hBw1pG__header",
  "loginBtn": "Header-module__hBw1pG__loginBtn",
  "logo": "Header-module__hBw1pG__logo",
  "mobileActions": "Header-module__hBw1pG__mobileActions",
  "mobileMenu": "Header-module__hBw1pG__mobileMenu",
  "mobileMenuButton": "Header-module__hBw1pG__mobileMenuButton",
  "nav": "Header-module__hBw1pG__nav",
  "registerBtn": "Header-module__hBw1pG__registerBtn",
  "scrolled": "Header-module__hBw1pG__scrolled",
});
